/**
 * News Section — Tab Filter (client-side, no page reload)
 *
 * Shows max MAX_VISIBLE items matching the clicked category slug.
 * Uses class .news-item--hidden (not HTML `hidden` attribute) so it wins
 * over `.news-item { display: block }` without !important.
 */

const MAX_VISIBLE = 5;

function applyFilter(container, activeSlug) {
  const items = Array.from(container.querySelectorAll('.news-item'));
  const empty = container.querySelector('[data-news-empty]');

  let shown = 0;
  let firstVisible = null;

  items.forEach((item) => {
    const cat = item.getAttribute('data-news-cat') || '';
    const matches = activeSlug === 'all' || cat === activeSlug;
    item.classList.remove('news-item--first');

    if (matches && shown < MAX_VISIBLE) {
      item.classList.remove('news-item--hidden');
      if (!firstVisible) firstVisible = item;
      shown++;
    } else {
      item.classList.add('news-item--hidden');
    }
  });

  if (firstVisible) firstVisible.classList.add('news-item--first');
  if (empty) {
    empty.classList.toggle('news-section__empty--visible', shown === 0);
  }
}

export default function initNewsFilter() {
  const containers = document.querySelectorAll('[data-news-filter]');
  containers.forEach((container) => {
    const tabs = container.querySelectorAll('[data-news-tab]');
    if (!tabs.length) return;

    // Initial render based on whichever tab is marked .is-active (default: すべて)
    const initialTab = container.querySelector('[data-news-tab].is-active') || tabs[0];
    applyFilter(container, initialTab.getAttribute('data-news-tab'));

    tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        tabs.forEach((t) => t.classList.remove('is-active'));
        tab.classList.add('is-active');
        applyFilter(container, tab.getAttribute('data-news-tab'));
      });
    });
  });
}
